export default "__VITE_ASSET__BI9pnMDj__"